<template>
  <div id="hrms27u">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            @setDataRowIndex="searchIndexDataRow = arguments[0]"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms27uIndex"
            searchBoxAlias="hrms27u"
            :approveEvent="approveEvent"
            :editInlineEventBool="true"
            :saveInlineEvent="callSave"
            :saveInlineBtnDisp="false"
            :columnEvent="columnEvent"
            ref="hrms27uIndexSearchBoxTable" />

    <input data-toggle="modal" data-target="#hrms27u-popup-request" ref="popupRequest" type="hidden"/>
    <input data-toggle="modal" data-target="#hrms27u-popup-applinf" ref="popupApplinf" type="hidden"/>

    <div name="hrms27u-popup-request" id="hrms27u-popup-request" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header header-popup">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ stdreqLabels[dash.nowLang]['STD_REQP1']['10'] }}</h4>
          </div>

          <div class="modal-body detail detail-responsive">
            <stdreq-detail :data="stdreqIndex" :labels="stdreqLabels[dash.nowLang]" :columns="stdreqColumn[dash.nowLang].index" />
          </div>
        </div>
      </div>
    </div>
    <div name="hrms27u-popup-applinf" id="hrms27u-popup-applinf" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header header-popup">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ stdapplinfLabels[dash.nowLang]['HRRC21P1']['1170'] }}</h4>
          </div>

          <div class="modal-body detail detail-responsive">
            <stdapplinf-detail  :data="stdapplinfIndex"
                                :labels="stdapplinfLabels[dash.nowLang]"
                                :columns="stdapplinfColumn[dash.nowLang]"
                                :dataTappoinf="dataTappoinf"
                                :receivedStdapplinfTappoinf="receivedStdapplinfTappoinf" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms27u/mutation-types'
import * as stdapplinfTypes from 'store/modules/stdapplinf/mutation-types'
import * as stdreqTypes from 'store/modules/stdreq/mutation-types'
import moment from 'moment'
import swal from 'sweetalert'
import stdapplinfDetail from 'components/stdapplinf/stdapplinfDetail'
import stdreqDetail from 'components/stdreq/stdreqDetail'

export default {
  name: 'hrms27u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve',
      searchIndex: {
        numreq: '',
        codpos: '',
        dtestrt: '01/' + moment().format('MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY')
      },
      searchIndexDataRow: {}
    }
  },
  watch: {
    'searchIndexDataRow.numreq' () {
      if (this.searchIndexDataRow.numreq) {
        this.searchIndex.codpos = this.searchIndexDataRow.numreq.codpos
      }
    }
  },
  created () {
    this.receivedHrms27uColumnsLabels()
    this.receivedStdapplinfColumnsLabels()
    this.receivedStdreqColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    dteappr () {
      let dteappr = moment().format('DD/MM/YYYY')
      return dteappr
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS27U_INDEX_DISP,
      columns: types.GET_HRMS27U_COLUMNS,
      labels: types.GET_HRMS27U_LABELS,
      index: types.GET_HRMS27U_INDEX,
      indexSelected: types.GET_HRMS27U_INDEX_SELECTED,
      indexInlineData: types.GET_HRMS27U_INDEX_INLINE_DATA,
      stdapplinfLabels: stdapplinfTypes.GET_STDAPPLINF_LABELS,
      stdapplinfIndex: stdapplinfTypes.GET_STDAPPLINF_INDEX,
      stdapplinfColumn: stdapplinfTypes.GET_STDAPPLINF_COLUMNS,
      dataTappoinf: stdapplinfTypes.GET_STDAPPLINF_TAPPOINF,
      stdreqLabels: stdreqTypes.GET_STDREQ_LABELS,
      stdreqIndex: stdreqTypes.GET_STDREQ_INDEX,
      stdreqColumn: stdreqTypes.GET_STDREQ_COLUMNS
    })
  },
  methods: {
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return (dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== '') || dataRow.flgEdit
      })
      if (dataRowsFiltered.length > 0) {
        for (let dataRow of dataRowsFiltered) {
          dataRow.flgEdit = true
        }
        this.$refs.hrms27uIndexSearchBoxTable.$emit('$searchBoxTableRef')
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setIndexInlineData(dataRowsHasFlg)
          this.postHrms27uSendApprove({ searchIndex: this.searchIndex, dataRows: dataRowsHasFlg, codappr: this.codempid, dteappr: this.dteappr })
        }
      })
    },
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'numappl':
          this.receivedStdapplinfIndex({ numappl: param[eventName] })
          this.$refs.popupApplinf.click()
          break
        case 'numreql':
          this.receivedStdreqIndex({ numreql: param[eventName] })
          this.$refs.popupRequest.click()
          break
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS27U_INDEX_SELECTED,
      setIndexInlineData: types.SET_HRMS27U_INDEX_INLINE_DATA
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS27U_PAGE,
      receivedHrms27uColumnsLabels: types.RECEIVED_HRMS27U_COLUMNS_LABELS,
      receivedHrms27uIndex: types.RECEIVED_HRMS27U_INDEX,
      postHrms27uSendApprove: types.POST_HRMS27U_SEND_APPROVE,
      receivedStdapplinfColumnsLabels: stdapplinfTypes.RECEIVED_STDAPPLINF_COLUMNS_LABELS,
      receivedStdapplinfIndex: stdapplinfTypes.RECEIVED_STDAPPLINF_INDEX,
      receivedStdapplinfTappoinf: stdapplinfTypes.RECEIVED_STDAPPLINF_TAPPOINF,
      receivedStdreqColumnsLabels: stdreqTypes.RECEIVED_STDREQ_COLUMNS_LABELS,
      receivedStdreqIndex: stdreqTypes.RECEIVED_STDREQ_INDEX
    })
  },
  components: {
    stdapplinfDetail,
    stdreqDetail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?3f49e352